'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGradient = function MdGradient(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 18.4v-10h-23.2v10h3.2v3.2h3.4v3.4h3.4v-3.4h3.2v3.4h3.4v-3.4h3.4v-3.2h3.2z m-3.2 11.6v-3.4h-3.4v3.4h3.4z m-6.8 0v-3.4h-3.2v3.4h3.2z m-6.6 0v-3.4h-3.4v3.4h3.4z m16.6-25c1.8 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.6 3.4-3.4 3.4h-23.2c-1.8 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.6-3.4 3.4-3.4h23.2z m-20 10h3.4v3.4h-3.4v-3.4z m13.4 0h3.4v3.4h-3.4v-3.4z m-6.6 0h3.2v3.4h3.4v3.2h-3.4v-3.2h-3.2v3.2h-3.4v-3.2h3.4v-3.4z m10 6.6v3.4h3.2v-3.4h-3.2z m-16.8 0h-3.2v3.4h3.2v-3.4z' })
        )
    );
};

exports.default = MdGradient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/gradient.js
// module id = 1076
// module chunks = 36573943044255 79611799117203 213534597649335